export const environment = {
  production: true,
  urlApiEndPointV3: 'https://apiformulafarma.healthfinder.es/',
  portalRole: 1,
  storagePrefix: 'front-admin-arias'
};
